import { useEffect, useRef } from "react";
import { Button } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";
import { useEntityClientWizard } from "../context";
import { canContinueCaseInfo, isLinkedOnboardingSubject } from "./utils";
import type { CaseInfoFormValues } from "./schema";

type Props = {
  onCancel: () => void;
};

export const CaseInfoFooter = ({ onCancel }: Props) => {
  const { setFooterContent, caseType, isProductLineLoading } = useEntityClientWizard();
  const { submitForm, isSubmitting, values } = useFormContext<CaseInfoFormValues>();

  const onCancelRef = useRef(onCancel);
  onCancelRef.current = onCancel;
  const submitRef = useRef(submitForm);
  submitRef.current = submitForm;

  const canContinue =
    canContinueCaseInfo(values, caseType) &&
    !(isLinkedOnboardingSubject(values, caseType) && isProductLineLoading);

  useEffect(() => {
    setFooterContent(
      <>
        <Button variant="neutral" onClick={() => onCancelRef.current()} type="button">
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!canContinue || isSubmitting}
          onClick={() => void submitRef.current()}
          type="button"
          data-testid="case-info-continue"
        >
          Continue
        </Button>
      </>,
    );
    return () => setFooterContent(null);
  }, [setFooterContent, canContinue, isSubmitting]);

  return null;
};
